import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useGetDriversMutation } from "../../../store/api/lumi/drivers";
import { debounce } from "lodash";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import { ImpactScoreChart } from "./ImpactScoreChart";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useGetConceptsFiltersMutation } from "../../../store/api/lumi/concepts";
import { getType } from "../../../utils/date";

export const ImpactScore = (props) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [getDriver] = useGetDriversMutation();
    const [getVolumes] = useGetConceptsFiltersMutation();

    const totalDoc = props.totalDocCount;
    const conceptFilter = useMemo(
        () => JSON.stringify(getConceptFilter(props)),
        [props]
    );

    const {
        id,
        filters,
        setFilterDocCount,
    } = props;


    async function getDriversData() {
        setIsLoading(true);
        const conceptFilter = getConceptFilter(props);
        try {
            const { data: dataConcepts } = await getDriver({
                id: props.id,
                score_field: props.selectedFieldDriverName,
                concept_selector: conceptFilter,
                filter: props.filters,
                match_type: getType(props.seletctedType),
            });

            if (dataConcepts && props.conceptList) {
                props.setLocalConceptOptions(dataConcepts);
            }

            const updatedData = dataConcepts.map(driver => ({
                ...driver,
                impactScore: (driver.match_count * driver.impact / (totalDoc - driver.match_count)*100),
            })).sort((a, b) => b.impactScore - a.impactScore);

            setData(updatedData);
            setIsLoading(false);

        } catch (error) {
            console.error("Error fetching driver data:", error);
            setIsLoading(false);

        }
    }

    const getConcepts = useCallback(async () => {
        const conceptFilter = getConceptFilter(props);
        const { data: dataConcepts } = await getVolumes({
            id,
            concept_selector: conceptFilter,
            filter: filters,
        });
        setFilterDocCount(dataConcepts.filter_count);
    }, [conceptFilter, filters, getVolumes, id, setFilterDocCount]);


    useEffect(() => {
        setIsLoading(true);
        if (props.selectedFieldDriverName && totalDoc) {
            const debouncedGetVolume = debounce(getDriversData, 500);
            debouncedGetVolume();

            return () => {
                debouncedGetVolume.cancel();
            };
        }
    }, [props.selectedFieldDriverName, props.seletctedType, props.conceptList, totalDoc,
        props.selectedPageSize,
        props.filters,
        props.conceptTypeDay,
        props.selectedLocalConcepts,
        props.conceptList]);

    useEffect(() => {
        setIsLoading(true);
        const debouncedGetConcepts = debounce(getConcepts, 500);

        debouncedGetConcepts();

        return () => {
            debouncedGetConcepts.cancel();
        };
    }, [getConcepts]);

    if (isLoading || !totalDoc) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }

    return (
        <div  style={{height: props.widget.layout.h * 39 - 150}}>
            {data.length > 0 ? <ImpactScoreChart data={data} props={props} /> : <p>No data available</p>}
        </div>
    );
};

export default ImpactScore;
